import React from 'react';
import { Tooltip, Icon } from 'antd';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { getValidationRules } from './utils';
import { useAlisaAudioManagerState } from '../../../../../../shared/lib/alisaAudioManager';
import Actions from './components/Actions/Actions';
import styles from './AlisaTextField.module.scss';

const placeholder = `(Пишите лаконично. Несколько отключений произносятся поочередно) 
По вашему адресу отключено электричество до 16:00 3 сентября`;

const AlisaTextField = ({ form, initialValue, editMode = false }) => {
  const initVal = initialValue?.trim() || '';

  const playingShutdownId = useAlisaAudioManagerState();

  const enableAlisa = form.getFieldValue(fieldNames.enableAlisa);

  return (
    <>
      <Field
        fieldType={fieldTypes.textArea}
        form={form}
        name={fieldNames.alisaText}
        label={
          <span>
            Текст автоответа&nbsp;
            <Tooltip title="При звонке в аварийно-диспетчерскую службу активируется автоинформатор с текстом автоответа">
              <Icon
                type="info-circle"
                style={{ fontSize: '16px' }}
              />
            </Tooltip>
            &nbsp;
            <span className={styles.accentLabel}>
              Проигрывается после приветствия, если оно подключено
            </span>
          </span>
        }
        decoratorOptions={{
          initialValue: initVal || '',
          rules: getValidationRules({
            initialValue: initVal,
            editMode,
            enableAlisa,
          }),
        }}
        fieldProps={{
          autoSize: { minRows: 2 },
          disabled: Boolean(playingShutdownId),
          placeholder,
        }}
      />
      <div className={styles.actions}>
        <Actions form={form} />
      </div>
    </>
  );
};

export default AlisaTextField;
